import { render, staticRenderFns } from "./kdSwitchMainAudit.vue?vue&type=template&id=5829fd70&scoped=true"
import script from "./kdSwitchMainAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./kdSwitchMainAudit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5829fd70",
  null
  
)

export default component.exports